import { useMutation } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { CreateTimelineSectionPayload, TimelineSection } from 'views/Tasks/Timeline/types';

export const createTimelineSection = async (
    { orgId, dealId, postData = {} }: { orgId: string; dealId: number; postData?: CreateTimelineSectionPayload },
): Promise<TimelineSection> => {
    const response = await axiosInstance.post<TimelineSection>(API_ENDPOINTS.TIMELINE_SECTIONS(orgId, dealId), postData);
    return response.data;
};

export const useCreateTimelineSection = () => useMutation({
    mutationFn: createTimelineSection,
});
